















































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import TaskApi from "@/module/task/TaskApi";
import Task, {taskStatusZh} from "@/model/Task";
import {PagingQueryForm, PqForm} from "biz-ts/src/api/Paging";
import Pagination from '@/component/Pagination/index.vue'
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import PaginationTable from "@/component/Table/pagination-table.vue";
import InfoDialog from "@/component/Dialog/info-dialog.vue";
import ServerTask from "@/model/ServerTask";
import VueJsonPretty from 'vue-json-pretty';
import IdColumn from "@/component/Table/id-column.vue";
import {Container} from "typescript-ioc";

@Component({
  components: {
    IdColumn,
    InfoDialog,
    Pagination,
    DeleteDialog,
    CreateDialog,
    RefreshButton,
    PaginationTable,
    VueJsonPretty,
  },
})
export default class TaskView extends Vue {

  private taskApi = Container.get(TaskApi)

  private pqForm: PagingQueryForm = new PqForm()

  @Ref()
  private ptable!: PaginationTable

  @Ref()
  private cancelDialog!: DeleteDialog

  @Ref()
  private detailDialog!: InfoDialog

  @Ref()
  private failReasonDialog!: InfoDialog

  private active = new Task()

  private get activeContentDesc() {
    if (this.active && this.active.contentDesc)
      return JSON.parse(this.active.contentDesc)
    else return undefined
  }

  private taskStatusValues = taskStatusZh

  private async getPaging() {
    return this.taskApi.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private statusFmt(task: ServerTask) {
    return this.taskStatusValues[task.status]
  }

  private spendTimeFmt(task: ServerTask) {
    const spendTime = task.spendTime
    let spendTimeFmt = ""
    if (spendTime == undefined) spendTimeFmt = "--"
    else if (spendTime < 1000) spendTimeFmt = spendTime + "ms"
    else {
      spendTimeFmt = this.msToTime(spendTime)
    }
    return spendTimeFmt
  }

  private msToTime(time: number) {
    const ms = time % 1000;
    time = (time - ms) / 1000;
    const secs = time % 60;
    time = (time - secs) / 60;
    const mins = time % 60;
    const hrs = (time - mins) / 60;

    let fmt = ''
    if (hrs > 0)
      fmt += hrs + 'h '
    if (mins > 0)
      fmt += mins + 'm '
    if (secs > 0)
      fmt += secs + 's '
    fmt += ms + 'ms'
    return fmt
  }

  private openDetailDialog(task: ServerTask) {
    this.active = task
    this.detailDialog.open()
  }

  private openFailReasonDialog(task: ServerTask) {
    this.active = task
    this.failReasonDialog.open()
  }
}
